<template>
  <div class="information">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="平台月租设置" name="first" v-if="roleObj.includes('153')">
        <PlatformMonthlyRentImport v-if="activeName == 'first'"></PlatformMonthlyRentImport>
      </el-tab-pane>
      <el-tab-pane label="独立站月租导入" name="second" v-if="roleObj.includes('154')">
        <IndependentStationMonthlyRentImport v-if="activeName == 'second'"></IndependentStationMonthlyRentImport>
      </el-tab-pane>
      <el-tab-pane label="独立站套餐设置" name="third" v-if="roleObj.includes('183')">
        <IndependentStationComboRentImport v-if="activeName == 'third'"></IndependentStationComboRentImport>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import PlatformMonthlyRentImport from './PlatformMonthlyRentImport/PlatformMonthlyRentImport'
import IndependentStationMonthlyRentImport from './IndependentStationMonthlyRentImport/IndependentStationMonthlyRentImport'
import IndependentStationComboRentImport from './IndependentStationComboRentImport/IndependentStationComboRentImport'
export default {
  name: 'FeeImport',
  components: {
    PlatformMonthlyRentImport,
    IndependentStationMonthlyRentImport,
    IndependentStationComboRentImport
  },
  data() {
    return {
      activeName: 'second',
      roleObj: ''
    }
  },
  mounted() {
    this.roleObj = JSON.parse(localStorage.getItem("role")).jurisdiction
  }
}
</script>
